export default __webpack_public_path__ + "static/media/kanipakamHistoryThree.1429353b.png";